<div class="page-service-indisponible page-container">
  <div class="image">
    <img src="{{ 'assets/images/indisponible.svg' | cheminAbsoluStatique }}" alt="" width="425" height="168" />
  </div>
  <div class="content-body">
    <div class="content-box">
      <h1 class="titre" id="titre-fr">Toutes nos excuses!</h1>
      <div class="texte" id="texte-fr">
        L'outil Ma première maison n’est pas accessible pour le moment. Veuillez réessayer plus tard.
      </div>
      <button mat-button id="btn-retour-sommaire-fr" class="no-border btn-retour" (click)="retourSommaire()">
        <img src="{{ 'assets/images/arrow/green-left.svg' | cheminAbsoluStatique }}" alt="" class="button-icone-left" />
        Retour au sommaire
      </button>
    </div>
    <div class="separator"></div>
    <div class="content-box">
      <h1 class="titre" id="titre-en">We’re sorry!</h1>
      <div class="texte" id="texte-en">My First Home is currently unavailable.<br />Please try again later.</div>
      <button mat-button id="btn-retour-sommaire-en" class="no-border btn-retour" (click)="retourSommaire()">
        <img src="{{ 'assets/images/arrow/green-left.svg' | cheminAbsoluStatique }}" alt="" class="button-icone-left" />
        Back to Overview
      </button>
    </div>
  </div>
</div>
